import { render, staticRenderFns } from "./OverviewReportingHint.vue?vue&type=template&id=9720227c&scoped=true&"
import script from "./OverviewReportingHint.vue?vue&type=script&lang=js&"
export * from "./OverviewReportingHint.vue?vue&type=script&lang=js&"
import style0 from "./OverviewReportingHint.vue?vue&type=style&index=0&id=9720227c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9720227c",
  null
  
)

export default component.exports